// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Mv7W","requiredAsterisk":"Info_requiredAsterisk__1iWEc"};